import React from 'react';
import { ArrowRight, Clock, Calendar } from 'lucide-react';
import { motion } from 'framer-motion';
import { ARTICLES } from '../data/articles';
import { useNavigate } from 'react-router-dom';

const InsightsSection = () => {
  const navigate = useNavigate();
  const featured = ARTICLES.slice(0, 3);

  return (
    <section id="insights" className="bg-[#FDFEFA] py-12 md:py-20 border-t border-[#242326]/5" data-testid="insights-section">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14 gap-4">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-[#242326] text-3xl md:text-5xl font-light leading-tight tracking-tight font-['Inter']"
          >
            Latest Insights
          </motion.h2>

          <motion.button
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            onClick={() => navigate('/insights')}
            data-testid="view-all-insights-button"
            className="inline-flex items-center gap-2 text-[#83BF42] text-sm font-['Inter'] hover:gap-3 transition-all"
          >
            View all posts
            <ArrowRight className="w-4 h-4" />
          </motion.button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((article, index) => (
            <motion.article
              key={article.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-30px' }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="group cursor-pointer"
              data-testid={`home-insights-card-${article.slug}`}
              onClick={() => navigate(`/insights/${article.slug}`)}
            >
              <div className="relative overflow-hidden rounded-xl mb-5">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-[220px] object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-white/90 backdrop-blur-sm text-[#242326] text-xs font-medium font-['Inter'] px-3 py-1 rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-3 mb-2">
                <span className="text-[#B8B8B8] text-xs font-['Lato'] flex items-center gap-1">
                  <Calendar className="w-3 h-3" /> {article.date}
                </span>
                <span className="text-[#B8B8B8] text-xs font-['Lato'] flex items-center gap-1">
                  <Clock className="w-3 h-3" /> {article.readTime}
                </span>
              </div>

              <h3 className="text-[#242326] text-lg md:text-xl font-medium font-['Inter'] mb-2 group-hover:text-[#83BF42] transition-colors duration-300 leading-snug">
                {article.title}
              </h3>

              <p className="text-[#4A4A48] text-sm font-['Lato'] font-light leading-relaxed line-clamp-2">
                {article.excerpt}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InsightsSection;
